import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api-service";

import { success } from "./notificationSlice";
import { setSurvey } from "./surveySlice";

const initialState = {
  template: {},
  templates: [],
};

export const addNewTemplate = createAsyncThunk(
  "addTemplate",
  async (template, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post("add-template", template);
      if (response?.ok) {
        dispatch(success({ message: "Template added successfully" }));
        dispatch(getAllTemplate({ search: "" }));
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTemplate = createAsyncThunk(
  "getTemplate",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get(`get-template/${id}`);
      if (response?.ok) return { ...response };
      else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateTemplate = createAsyncThunk(
  "updateTemplate",
  async (template, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(
        `update-template/${template.id}`,
        template
      );
      if (response?.ok) {
        dispatch(success({ message: "Template updated successfully" }));
        dispatch(getAllTemplate({ search: "" }));
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "deleteTemplate",
  async (template, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.delete(`delete-template/${template.id}`);
      if (response?.ok) {
        dispatch(success({ message: "Template deleted successfully" }));
        dispatch(getAllTemplate({ search: "" }));
        dispatch(removeTemplate({}));
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllTemplate = createAsyncThunk(
  "getAllTemplate",
  async ({ search }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get(
        `get-templates?searchText=${search}&pageSize=1000`
      );
      if (response?.ok) {
        dispatch(
          setSurvey({
            field: "templateId",
            value: response.data.data.data[0]?.id,
          })
        );
        dispatch(
          setSurvey({
            field: "templateName",
            value: response.data.data.data[0]?.name,
          })
        );
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    addTemplate: (state, action) => {
      state.template[action.payload.type] = action.payload.value;
    },
    setTemplate: (state, action) => {
      state.template = action.payload;
    },
    removeTemplate: (state, action) => {
      state.template = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplate.fulfilled, (state, action) => {
        state.template = action.payload.data.data;
      })
      .addCase(addNewTemplate.fulfilled, (state, action) => {
        state.template = action.payload.data.data;
      })
      .addCase(getAllTemplate.fulfilled, (state, action) => {
        state.templates = action.payload.data.data;
      });
  },
});

// Action creators are generated for each case reducer function
export const { addTemplate, setTemplate, removeTemplate } =
  templateSlice.actions;
export const templateSelector = (state) => state.template.template;
export const templatesSelector = (state) => state.template.templates;

export default templateSlice.reducer;
